import { gql, useMutation, useQuery } from '@apollo/client'

import { ApiTabletWorkoutFavorite, TabletWorkoutFavoriteInput } from 'lib/favoriteWorkouts'

interface TabletWorkoutFavoritesData {
  tabletWorkoutFavorites: ApiTabletWorkoutFavorite[]
}

interface ToggleTabletWorkoutFavoriteData {
  toggleTabletWorkoutFavorite: {
    favorite: ApiTabletWorkoutFavorite | null
    added: boolean
    limitReached: boolean
  }
}

interface ToggleTabletWorkoutFavoriteVariables {
  input: TabletWorkoutFavoriteInput
}

interface InitializeTabletWorkoutFavoritesData {
  initializeTabletWorkoutFavorites: ApiTabletWorkoutFavorite[]
}

interface InitializeTabletWorkoutFavoritesVariables {
  templateId: string
}

export const TABLET_WORKOUT_FAVORITES = gql`
  query TabletWorkoutFavorites {
    tabletWorkoutFavorites {
      id
      favoriteId
      kind
      templateId
      imageKey
      workoutSession
    }
  }
`

const TOGGLE_TABLET_WORKOUT_FAVORITE = gql`
  mutation ToggleTabletWorkoutFavorite($input: TabletWorkoutFavoriteInputSchema!) {
    toggleTabletWorkoutFavorite(input: $input) {
      favorite {
        id
        favoriteId
        kind
        templateId
        imageKey
        workoutSession
      }
      added
      limitReached
    }
  }
`

const INITIALIZE_TABLET_WORKOUT_FAVORITES = gql`
  mutation InitializeTabletWorkoutFavorites($templateId: String!) {
    initializeTabletWorkoutFavorites(templateId: $templateId) {
      id
      favoriteId
      kind
      templateId
      imageKey
      workoutSession
    }
  }
`

export const useTabletWorkoutFavoritesQuery = () => useQuery<TabletWorkoutFavoritesData>(
  TABLET_WORKOUT_FAVORITES,
  { fetchPolicy: 'cache-and-network' },
)

export const useToggleTabletWorkoutFavoriteMutation = () => useMutation<
  ToggleTabletWorkoutFavoriteData,
  ToggleTabletWorkoutFavoriteVariables
>(TOGGLE_TABLET_WORKOUT_FAVORITE, {
  awaitRefetchQueries: true,
  refetchQueries: [{ query: TABLET_WORKOUT_FAVORITES }],
})

export const useInitializeTabletWorkoutFavoritesMutation = () => useMutation<
  InitializeTabletWorkoutFavoritesData,
  InitializeTabletWorkoutFavoritesVariables
>(INITIALIZE_TABLET_WORKOUT_FAVORITES, {
  awaitRefetchQueries: true,
  refetchQueries: [{ query: TABLET_WORKOUT_FAVORITES }],
})
